import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api/client';

export interface EnvVar {
  key: string;
  value: string;
  isSensitive: boolean;
}

export interface StripeInfo {
  accountType: 'Test Account' | 'Live Account' | 'Unknown';
  environment: 'development/test' | 'production' | 'unknown';
  accountId?: string;
  hasWebhookSecret: boolean;
  hasPublishableKey: boolean;
}

export interface EnvironmentSettings {
  envVars: EnvVar[];
  count: number;
  sensitiveCount: number;
  stripeInfo: StripeInfo | null;
}

export function useEnvironmentSettings() {
  return useQuery({
    queryKey: ['settings', 'environment'],
    queryFn: () => apiClient<EnvironmentSettings>('/settings/environment'),
  });
}
